import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Collapse,
  Divider,
} from "@mui/material";
import {
  Wrench,
  ChevronDown,
  ChevronUp,
  ExternalLink,
} from "@mynaui/icons-react";

const ServiceItem = ({ service, defaultExpanded, isLast, isFirst }) => {
  const [expanded, setExpanded] = useState(defaultExpanded || false);

  return (
    <>
      <Box>
        {/* Header row */}
        <Box
          onClick={() => setExpanded(!expanded)}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: 1,
            marginTop: isFirst ? "8px" : "24px",
            marginBottom: "10px",
            cursor: "pointer",
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "24px",
              color: "#020618",
            }}
          >
            {service.title}
          </Typography>
          {expanded ? (
            <ChevronUp size={20} color="#6B7280" strokeWidth={1.5} />
          ) : (
            <ChevronDown size={20} color="#6B7280" strokeWidth={1.5} />
          )}
        </Box>

        {/* Expanded content */}
        <Collapse in={expanded}>
          <Box sx={{ pb: 2 }}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "16px",
                color: "#62748E",
                mb: 2.5,
              }}
            >
              {service.date}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                lineHeight: "20px",
                color: "#374151",
                mb: 1.5,
              }}
            >
              {service.details}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{ fontSize: "14px", lineHeight: "20px", color: "#16A34A" }}
              >
                {service.status}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#020618",
                  }}
                >
                  {service.approvedBy}
                </Typography>
                <ExternalLink size={20} color="#020618" strokeWidth={1.5} />
              </Box>
            </Box>
          </Box>
        </Collapse>
      </Box>

      {!isLast && <Divider sx={{ borderColor: "#E5E7EB" }} />}
    </>
  );
};

const ServiceHistory = ({ services }) => {
  return (
    <Card
      elevation={0}
      sx={{
        flex: 1,
        border: "none",
        background: "#F1F5F9",
        boxShadow: "none"
      }}
    >
      <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <Wrench size={24} color="#020618" strokeWidth={1.5} />
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "18px",
              lineHeight: "28px",
              color: "#111827",
            }}
          >
            Service History
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", px: 1 }}>
          {services.map((service, index) => (
            <ServiceItem
              key={service.id}
              service={service}
              defaultExpanded={index === 0}
              isFirst={index === 0}
              isLast={index === services.length - 1}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ServiceHistory;
